import { LABEL_FIRST_BEGIN_CURVE, formatECLabel, formatCombinedCurveLabel, } from "../site/arbitrary-line/constants";
/**
 * Determine whether the segment contains BP
 */
export function isSegmentContainingBP(segmentIndex, totalSegments) {
    return segmentIndex === 0;
}
/**
 * Determine whether the segment contains EP
 */
export function isSegmentContainingEP(segmentIndex, totalSegments) {
    return segmentIndex === totalSegments - 1;
}
/**
 * Generate a midpoint label based on the new specifications
 */
export function generateMidpointLabel(segmentId, segments) {
    const segmentIndex = segments.findIndex((segment) => segment.id === segmentId);
    const totalSegments = segments.length;
    if (segmentIndex === -1) {
        return "Midpoint"; // Fallback
    }
    const containsBP = isSegmentContainingBP(segmentIndex, totalSegments);
    const containsEP = isSegmentContainingEP(segmentIndex, totalSegments);
    if (containsBP && !containsEP) {
        return LABEL_FIRST_BEGIN_CURVE;
    }
    if (containsEP && !containsBP) {
        return formatECLabel(segmentIndex);
    }
    if (!containsBP && !containsEP) {
        return formatCombinedCurveLabel(segmentIndex, segmentIndex + 1);
    }
    return LABEL_FIRST_BEGIN_CURVE; // Fallback for single segment
}
//# sourceMappingURL=linework-cross-section-handler-helper.js.map